export default __webpack_public_path__ + "static/media/Kwikr_banner.95d72ae7.png";